import { appConfig } from "../../../../utils/app.config";


export const getBotDetailsAPI = appConfig.baseUrl + "/gwt/api/v2.0/litebot/admin/session/getBotDetails/";
export const getKbDetailsAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const updateDetailsAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const getCustomKbAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const addDetailsAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const deleteKbDetailsAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const publishDetailsAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const getBotResolutionAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const getPublishAPI = appConfig.baseUrl + "/api/v2.0/pythonAgent/agentApi";
export const botProfilesAPI = appConfig.baseUrl + "/api/v2.0/litebot/activebots";

export const kbSummaryApiUrl = appConfig.baseUrl + "/gwt/api/v2.0/litebot/admin/session/kb-summary";
// export const botProfilesAPI = appConfig.baseUrl + "/api/v2.0/litebot/activebots";